module.exports = __webpack_public_path__ + "img/section2Logo6.3ed6a3f7.png";